// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components/accolades-carousel/accolades-carousel.component.scss
// module id = 69
// module chunks = 0